import { useEffect, useRef, useState } from "react";

/**
 * Hook to reveal elements on scroll using IntersectionObserver.
 * Adds `is-visible` class when the element enters the viewport.
 */
export const useReveal = (options = {}) => {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const io = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          io.disconnect();
        }
      },
      { threshold: 0.15, rootMargin: "0px 0px -10% 0px", ...options }
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);

  return [ref, visible];
};

export const Reveal = ({ as: Tag = "div", className = "", variant = "up", delay = 0, children, ...props }) => {
  const [ref, visible] = useReveal();
  const base =
    variant === "line" ? "reveal-line" : variant === "in" ? "reveal-in" : "reveal-up";
  return (
    <Tag
      ref={ref}
      style={delay ? { animationDelay: `${delay}ms` } : undefined}
      className={`${base} ${visible ? "is-visible" : ""} ${className}`}
      {...props}
    >
      {children}
    </Tag>
  );
};

export default Reveal;
